module.exports = __webpack_public_path__ + "static/img/banner-img.8df1b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-img.png
// module id = 9c7B
// module chunks = 1